(function () {
    "use strict";
    
    let currentSyncScrollTimeout = null;
    let currentSyncScrollElement = null;

    /* CONTENT READY */
    
    $(window).load(function () {
        // Init table top scroller
        $(".table-outer-ctn .table-inner-wrap").each(function () {
            const $it = $(this);
            const $dum = $("<div class='table-top-scroller'><table></table></div>");
            // Insert before the target table wrap
            $dum.insertBefore($it);
            // Set the dummy table the same width as the real table and holding 
            // height to display the scroll bar
            $dum.find("table").css({
                width: $it.find("table").outerWidth(),
                height: "1px"
            });
            // In case the scroll has already happened after page refresh
            $dum.scrollLeft($it.scrollLeft());
            // Set scroll event to sync both scrollers
            $dum.on("scroll", syncScroll);
            $it.on("scroll", syncScroll);
        });
    });
    
    /* FUNCTIONS CONSTRUCTION */
    
    function syncScroll(e) {
        const $targ = $(e.currentTarget || this);
        const x = $targ.scrollLeft();
        
        if (currentSyncScrollElement === null) {
            // Assign the first active element
            currentSyncScrollElement = $targ[0];
        }
        // Prevent double event activation on both scrollbars
        if (currentSyncScrollElement === $targ[0]) {
            // Clear out the previous timeout
            if (currentSyncScrollTimeout !== null) {
                window.clearTimeout(currentSyncScrollTimeout);
            }
            // Sets new scroll timeout
            currentSyncScrollTimeout = window.setTimeout(function() {
                currentSyncScrollElement = null;
            }, 167);
            
            if ($targ.hasClass("table-top-scroller")) {
                // Scroll the main container
                $targ.next().scrollLeft(x);
            } else if ($targ.hasClass("table-inner-wrap")) {
                // Scroll the dummy
                $targ.prev().scrollLeft(x);
            }
        }
    }

})();